const FV = require('../../../components/form-validation/form-validation.script');
const onboardingService = require("../../../../services/onboard")
const donorsService = require("../../../../services/donors")
const swal = require('sweetalert')
// var files = [];
// var profileImage = {}
var formProfile = {
    files: [],
    profileImage: {}
}

export async function load() {

    document.getElementById("ongPictures")
        .addEventListener('change', (e) => {
            getFiles(e)
        })

    document.getElementById("minhaFoto")
        .addEventListener('change', updateProfilePicture)

    try {

        startForm(document.getElementById("etapa_6"))
        return true


    } catch (err) {
        console.log('err', err)
        return err
    }

}


//  a function to get files from input file and show in view
function getFiles(e) {
    var fileInput = document.querySelector("#ongPictures");
    // var files = fileInput.files;
    var alertMessageShowed = false;
    if (e) {
        Array.from(e.target.files).forEach((file, index) => {
            if (formProfile['files'].length < 5) {
                formProfile['files'].push(file)
            } else {
                if (alertMessageShowed == false) {
                    swal("Máximo de 5 arquivos atingido", "Você pode substituir algum arquivo se quiser", "error");
                    alertMessageShowed = true
                }
            }
        })
    }

    var htmlContainer = ''
    for (var i = 0; i < formProfile['files'].length; i++) {
        var file = formProfile['files'][i];
        htmlContainer = `
        <div class="fileListItem" item="${i}">
            <div class="info">
                <span class="name">${file.name}</span>
                <span class="size">${file.size} bytes</span>
            </div>
            <div class="action">
                <input type="button" id="deleteItem_${i}" item="${i}" />
            </div>
        </div>
        ${htmlContainer}`
    }
    // console.log('htmlContainer', htmlContainer)
    document
        .getElementById('upload_list')
        .innerHTML = htmlContainer;

    Array.from(document.querySelectorAll("input[type='button']"))
        .forEach((item, i) => {
            item.addEventListener('click', (_e) => {
                formProfile['files'].splice(item.getAttribute("item"), 1)
                getFiles()
            })
        });
}


function updateProfilePicture(e) {
    var file = e.srcElement.files[0]
    var output = document.getElementById('previewImage');
    formProfile['profileImage'] = file;
    output.src = URL.createObjectURL(file);
    output.onload = function () {
        URL.revokeObjectURL(output.src) // free memory
    }
}

function startForm(formEl) {
    formEl
        .addEventListener('submit', function (evt) {
            evt.preventDefault()
            FV.clearErrosMessages(formEl)
            sendForm(formEl)
        })
}

async function sendForm(formEl) {
    const userID = formEl.getAttribute("userID")
    const userType = formEl.getAttribute("userType")
    console.log("getFormValues", await FV.getFormValues(formEl))
    const formValues = await FV.getFormValues(formEl)

    // if (formValues.cadastrarNecessidades == "true") {
    if (FV.thisFormIsValid(formEl)) {
        const formData = await generateFormData(formEl)

        const button = document.getElementById('sendButton');

        if (!button.classList.contains('loading')) {
            button.classList.add('loading');
        }

        try {
            var saved = await onboardingService.saveProfile(userID, formData)
            if (userType != 'ong') {

                const userObject = await donorsService.getProfile(userID);

                if (userObject && userObject.data && userObject.data.verified != 'no') {
                        window.barba.go(`/cadastro/etapa_9?registerType=${userType}`);
                } else {
                    window.barba.go(`/cadastro/etapa_7/${userObject.data.hash}?registerType=${userType}`);
                }


            } else {
                window.barba.go(`/cadastro/etapa_7/${userID}`);
            }

            if (button.classList.contains('loading')) {
                button.classList.remove('loading');
            }

        } catch (err) {
            swal(err, "error");

            if (button.classList.contains('loading')) {
                button.classList.remove('loading');
            }
        }

        console.log('saved', saved)
    }
    // } else {
    //     window.barba.go(`/cadastro/etapa_6/${userID}`);
    // }

}



async function generateFormData(formEl) {
    var formData = new FormData();
    formProfile['files'].forEach((image, index) => {
        formData.append(`images[${index}]`, image, image.name);
    });
    const formValues = await FV.getFormValues(formEl)
    formData.append(`photo`, formProfile['profileImage'], formProfile['profileImage'].name);

    formData.append(`description`, formValues['description']);

    return formData
}
